import { render } from "./IndexPdf.vue?vue&type=template&id=6ded6db8"
import script from "./IndexPdf.vue?vue&type=script&lang=js"
export * from "./IndexPdf.vue?vue&type=script&lang=js"

import exportComponent from "/srv/guestwaiterreportingfront/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__